import React, { useEffect, useState } from "react";
import AddParticipant from "./AddParticipant";
import ParticipantTable from "./ParticipantTable";
import { useNavigate } from "react-router-dom";
import GridExample from "./ParticipantAGTable";
import ParticipantAGTable from "./ParticipantAGTable";
import { addParticipants, getParticipants } from "../../api/axiosApi";
import UserTables from "../users/userTables";
import { ParticipantsType, UsersType } from "../../utils/common";
// interface ParticipantsType {
//     participant_name: string;
//     participant_email: string;
//     participant_organization: string;
//     participant_link?: string;
// }
// interface ParticipantsType {
//     SNo: string;
//     Name: string;
//     Email: string;
//     Organization: string;
//     Link: string;
//     Role:string;
// }
interface Props {
    participantsData: UsersType[];
}

function ParticipantsManager() {
    const [participantsData, setParticipantsData] = useState<UsersType[]>([]);
    const navigate = useNavigate();
    // const addNewParticipant = async (participant_id: string, newParticipant: ParticipantsType): Promise<{ success: boolean; errorCode: string }> => {
    //     try {
    //         const addParticipant = await addParticipants(participant_id, newParticipant);
    //         // if (addParticipant.status === 401 || addParticipant.status === 422) {
    //         //     delete_user_data_from_client_side();
    //         //     navigate("/user_login");
    //         // }
    //         const addParticipantJson = await addParticipant.data;

    //         if ("error" in addParticipantJson && addParticipantJson.status === "failed") {
    //             return { success: false, errorCode: addParticipantJson.error };
    //         }

    //         const participantsRes = await getParticipants();
    //         // if (participantsRes.status === 401 || participantsRes.status === 422) {
    //         //     delete_user_data_from_client_side();
    //         //     navigate("/user_login");
    //         // }
    //         const participantsJsonRes = await participantsRes.data;
    //         setParticipantsData(participantsJsonRes);
    //         return { success: true, errorCode: "" };
    //     } catch (error) {
    //         return { success: false, errorCode: error instanceof Error ? error.message : "An unknown error occurred" };
    //     }
    // };

    useEffect(() => {
        async function fetchParticipants() {
            try {
                const participantsRes = await getParticipants();
                const participantsJsonRes = await participantsRes.data;
                setParticipantsData(participantsJsonRes);
            } catch (error) {
                console.error("Error fetching participants:", error);
            }
        }

        fetchParticipants();
    }, []);

    return (
        <>
            {/* <AddParticipant onAddParticipant={addNewParticipant} /> */}
            <UserTables participantsData={participantsData} ></UserTables>
            {/* <ParticipantAGTable participantsData={participantsData}></ParticipantAGTable> */}
        </>
    );
}

export default ParticipantsManager;
